import React from "react";
import { useNavigate } from "react-router-dom";

const VerificationProfile = ({ onClose, onOtp, onLogin }) => {
    


  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          maxWidth: 500,
          width: "100%",
          background: "#fff",
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          overflow: "hidden",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "12px 16px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{ margin: 0, color: "#00b4aa" }}>Alert</h3>
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "24px",
              cursor: "pointer",
              color: "#666",
            }}
          >
            ✖
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "16px", fontSize: "16px", color: "#7b7878ff" }}>
          <p style={{ marginBottom: "12px" }}>
            This phone number is registered with <b>RB Diagnostic</b>. <br />
            You can continue the Home Collection request after{" "}
            <b>Login in your account.</b>
          </p>
        </div>

        {/* Footer Buttons */}
        <div
          style={{
            padding: "12px 16px",
            display: "flex",
            justifyContent: "center",
            gap: "16px",
          }}
        >
          <button
            onClick={onOtp}
            style={{
              backgroundColor: "#00b4aa",
              border: "none",
              borderRadius: "6px",
              padding: "8px 20px",
              color: "#fff",
              fontWeight: "600",
              cursor: "pointer",
              boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
            }}
          >
            Get Otp
          </button>
          <button
            onClick={onLogin}
            style={{
              backgroundColor: "#00b4aa",
              border: "none",
              borderRadius: "6px",
              padding: "8px 20px",
              color: "#fff",
              fontWeight: "600",
              cursor: "pointer",
              boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
            }}
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationProfile;
